module.exports = "<app-header></app-header>\n<router-outlet></router-outlet>\n\n<app-footer></app-footer>\n"